/*
 * Launch the application from ./src/index.js
 */
import { Routes } from './routing';
import { HashRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from '@corefact/toolchain/components/ErrorBoundary';
import { POST } from '@corefact/toolchain/fetch-utils';
import React from 'react';

function Render({ error = false }) {
    createRoot(document.querySelector([
        `.${ENVConfig.application?.name?.replace?.(/[^0-9a-z_-]/gi, '_') || '__UNKNOWN__'}-toolchain-application`,
    ].find(elm => document.querySelector(elm)))).render((
        <ErrorBoundary>
            {
                error ? (
                    <div className="error">
                        <h1>Application Render Error</h1>
                        <pre>{JSON.stringify(error, null, 4)}</pre>
                    </div>
                ) : (
                    <HashRouter>
                        <Routes />
                    </HashRouter>
                )
            }
        </ErrorBoundary>
    ));
}

(() => {
    if (ENVConfig?.USEPROXY) {
        if (!ENVConfig?.PROXYAUTH?.user || !ENVConfig?.PROXYAUTH?.password) {
            return alert('Proxy authentication is not configured but enabled. Please configure proxy-auth.js');
        } else {
            return POST(`${ENVConfig.API_HOST_V3}/session`, {
                body: ENVConfig.PROXYAUTH, // Body contains user + password.
            }).then((result = {}) => {
                return result?.success ? Render({}) : Promise.reject(result);
            }).catch(error => Render({ error }));
        }
    }
    Render({});
})();
